<!-- @format -->

<div *transloco="let t">
  <h3 *ngIf="!hideTitle">{{ t("UNAUTHORIZED.TITLE") }}</h3>
  {{ t("UNAUTHORIZED.MESSAGE") }}
</div>
